import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { fetchUserAttributes } from "aws-amplify/auth";

export const fetchUserAttributesThunk = createAsyncThunk(
  "user/fetchUserAttributes", // Action type string
  async (_, { rejectWithValue }) => {
    try {
      // Fetch the user attributes from AWS Amplify Auth
      const attributes = await fetchUserAttributes();
      return attributes; // Return the fetched attributes if successful
    } catch (error) {
      console.error("Error fetching user attributes:", error.message);
      // Return the error message if the fetch fails
      return rejectWithValue(error.message);
    }
  }
);

// Create a Redux slice for handling user-related state
const userSlice = createSlice({
  name: "user", // Name of the slice
  initialState: {
    userAttributes: {}, // Object to store user attributes
    loading: false, // Flag to indicate if the fetch is in progress
    error: null, // Error message, if any
  },
  reducers: {
    // Reducer to clear the user attributes
    clearUserAttributes: (state) => {
      state.userAttributes = {}; // Reset the userAttributes to an empty object
      console.log("User attributes cleared");
    },
    // Reducer to set the user attributes explicitly
    setUserAttributes: (state, action) => {
      state.userAttributes = action.payload; // Set the userAttributes to the provided payload
      console.log("User attributes set:", action.payload);
    },
  },
  extraReducers: (builder) => {
    // Handle the different states of the asynchronous thunk action
    builder
      .addCase(fetchUserAttributesThunk.pending, (state) => {
        state.loading = true; // Set loading to true when the action is pending
        console.log("Fetching user attributes...");
      })
      .addCase(fetchUserAttributesThunk.fulfilled, (state, action) => {
        state.userAttributes = action.payload; // Store the fetched attributes
        state.loading = false; // Set loading to false when the action is fulfilled
      })
      .addCase(fetchUserAttributesThunk.rejected, (state, action) => {
        state.loading = false; // Set loading to false when the action is rejected
        state.error = action.payload; // Capture the error message
        console.error("Failed to fetch user attributes:", action.payload);
      });
  },
});

export const { clearUserAttributes, setUserAttributes } = userSlice.actions;

export default userSlice.reducer;
